module.exports = __webpack_public_path__ + "static/media/hp-group-mobile.4f1cff6a.svg";